import React = require("react");
import {Loader} from "../../../components/Utils/loader/Loader";

export class LoadingPage extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }
    public render() {
        return (
            <div className={"cover-content-container"}>
                <Loader/>
            </div>
        );
    }
}
